import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, List, Popup } from 'semantic-ui-react';

import { bem } from '../../core/design/bem';
import { Invited } from '../types';

const css = bem('InvitedList');
const translationPrefix = 'group-visits';

type InvitedListProps = {
  invited: Invited[];
};

function getInvitedName(invited: Invited, fallback: string): string {
  const name = [invited.firstName, invited.lastName].filter(Boolean).join(' ').trim();
  return name || invited.email || fallback;
}

const InvitedList = ({ invited }: InvitedListProps): JSX.Element | null => {
  const { t } = useTranslation();
  if (!invited.length) return null;

  return (
    <List divided relaxed className={css().toString()}>
      {invited.map((guest) => (
        <List.Item key={guest._id} className={css('item').toString()}>
          <List.Content className={css('main').toString()}>
            <Icon
              name={guest.registered ? 'check circle' : 'circle outline'}
              color={guest.registered ? 'green' : 'grey'}
              title={
                guest.registered
                  ? t(`${translationPrefix}.invited.registered`)
                  : t(`${translationPrefix}.invited.not-registered`)
              }
            />
            <span className={css('name').toString()}>
              {getInvitedName(guest, t(`${translationPrefix}.invited.anonymous`))}
            </span>
          </List.Content>
          <List.Content className={css('badges').toString()}>
            {guest.pmr === 'yes' && (
              <Popup
                content={t(`${translationPrefix}.invited.pmr`)}
                trigger={
                  <Icon
                    name="wheelchair"
                    className={cx(css('badge').toString(), css('badge', { pmr: true }).toString())}
                  />
                }
              />
            )}
            {guest.parking === 'yes' && (
              <Popup
                content={
                  guest.licensePlate
                    ? t(`${translationPrefix}.invited.parking-with-plate`, {
                        plate: guest.licensePlate,
                      })
                    : t(`${translationPrefix}.invited.parking`)
                }
                trigger={
                  <span className={css('parking').toString()}>
                    <Icon name="car" />
                    {guest.licensePlate && (
                      <span className={css('plate').toString()}>{guest.licensePlate}</span>
                    )}
                  </span>
                }
              />
            )}
          </List.Content>
        </List.Item>
      ))}
    </List>
  );
};

export default InvitedList;
